import {Component, Input} from '@angular/core';
import {TrendResponse} from '@npck/af-frontend-api';

@Component({
    selector: 'af-trend-details-tab',
    templateUrl: 'trend-details-tab.component.html',
    styleUrls: ['trend-details-tab.component.scss'],
    standalone: false,
})
export class TrendDetailsTabComponent {
    @Input() trend: TrendResponse;
}
